import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LabelWithLinkModule } from '../../atoms/label-with-link/label-with-link.module';
import { ButtonModule } from '../../forms/button/button.module';
import { ButtonWithLinkComponent } from './button-with-link.component';

@NgModule({
  declarations: [ButtonWithLinkComponent],
  imports: [CommonModule, ButtonModule, LabelWithLinkModule],
  exports: [ButtonWithLinkComponent]
})
export class ButtonWithLinkModule {}
